class Init {

    constructor() {
       this.initial();
    }

    initial() {
           if (window.NodeList && !NodeList.prototype.forEach) {
                NodeList.prototype.forEach = Array.prototype.forEach;
            }

    setTimeout(() => {
        document.getElementsByTagName('body')[0].classList.remove('preload');
      

    }, 300)

    }
}

export default Init;